<template>
  <footer class="bg-gray-800 text-white py-8 mt-16">
    <div class="max-w-7xl mx-auto px-4">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- 公司信息 -->
        <div class="col-span-1 md:col-span-2">
          <div class="flex items-center mb-4">
            <i class="fas fa-broadcast-tower text-purple-400 text-2xl mr-2"></i>
            <span class="text-xl font-bold">Withflows</span>
          </div>
          <p class="text-gray-300 mb-4">
            {{ $store.getters.t('footer_description') }}
          </p>
          <div class="flex space-x-4">
            <a href="#" class="text-gray-300 hover:text-white">
              <i class="fab fa-weixin text-xl"></i>
            </a>
            <a href="#" class="text-gray-300 hover:text-white">
              <i class="fab fa-weibo text-xl"></i>
            </a>
            <a href="#" class="text-gray-300 hover:text-white">
              <i class="fab fa-qq text-xl"></i>
            </a>
          </div>
        </div>
        
        <!-- 产品服务 -->
        <div>
          <h3 class="text-lg font-semibold mb-4">{{ $store.getters.t('footer_products') }}</h3>
          <ul class="space-y-2">
            <li><a href="#" class="text-gray-300 hover:text-white">{{ $store.getters.t('footer_smart_live_assistant') }}</a></li>
            <li><a href="#" class="text-gray-300 hover:text-white">{{ $store.getters.t('footer_data_analysis') }}</a></li>
            <li><a href="#" class="text-gray-300 hover:text-white">{{ $store.getters.t('footer_content_management') }}</a></li>
            <li><a href="#" class="text-gray-300 hover:text-white">{{ $store.getters.t('footer_fan_interaction') }}</a></li>
          </ul>
        </div>
        
        <!-- 联系我们 -->
        <div>
          <h3 class="text-lg font-semibold mb-4">{{ $store.getters.t('footer_contact') }}</h3>
          <ul class="space-y-2">
            <li class="text-gray-300">
              <i class="fas fa-phone mr-2"></i>
              {{ $store.getters.t('footer_phone') }}
            </li>
            <li class="text-gray-300">
              <i class="fas fa-envelope mr-2"></i>
              {{ $store.getters.t('footer_email') }}
            </li>
            <li class="text-gray-300">
              <i class="fas fa-map-marker-alt mr-2"></i>
              {{ $store.getters.t('footer_address') }}
            </li>
          </ul>
        </div>
      </div>
      
      <!-- 版权信息 -->
      <div class="border-t border-gray-700 mt-8 pt-8 text-center">
        <p class="text-gray-400">
          {{ $store.getters.t('footer_copyright') }} | 
          <a href="#" class="text-gray-300 hover:text-white">{{ $store.getters.t('footer_privacy') }}</a> | 
          <a href="#" class="text-gray-300 hover:text-white">{{ $store.getters.t('footer_terms') }}</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script> 